import styled from 'styled-components';
import Parent from './style';

const Container = styled(Parent.Container)``;
const Styled = { Container };
export default Styled;
